<template>
  <v-container>
    <v-layout row wrap>
      <v-flex xs4 sm3>
        <ProfileSidebar active="transaction" />
      </v-flex>
      <v-flex xs7 sm8 offset-xs1>
        <h1>Transaction</h1>
        <br />
        <v-layout class="space-between text-xs-center">
          <v-card class="mw-20">
            <v-card-title>
              <h3 class="mx-auto">Total Added</h3>
            </v-card-title>
            <v-card-text>
              <h4>{{ balance ? balance.total_added : 0 }}</h4>
            </v-card-text>
          </v-card>

          <v-card class="mw-20">
            <v-card-title>
              <h3 class="mx-auto">Total Balance</h3>
            </v-card-title>
            <v-card-text>
              <h4>{{ balance ? balance.total_balance : 0 }}</h4>
            </v-card-text>
          </v-card>

          <v-card class="mw-20">
            <v-card-title>
              <h3 class="mx-auto">Available Balance</h3>
            </v-card-title>
            <v-card-text>
              <h4>{{ balance ? balance.available_balance : 0 }}</h4>
            </v-card-text>
          </v-card>

          <v-card class="mw-20">
            <v-card-title>
              <h3 class="mx-auto">Holding Balance</h3>
            </v-card-title>
            <v-card-text>
              <h4>{{ balance ? balance.holding_balance : 0 }}</h4>
            </v-card-text>
          </v-card>

          <v-card class="mw-20">
            <v-card-title>
              <h3 class="mx-auto">Total Cost</h3>
            </v-card-title>
            <v-card-text>
              <h4>{{ balance ? balance.total_cost : 0 }}</h4>
            </v-card-text>
          </v-card>
        </v-layout>
        <br />
        <!-- <br /> -->
        <v-layout class="space-between">
          <v-btn
            round
            large
            color="success"
            class="mx-0"
            @click="$router.push('/client-payment-page')"
          >
            Top Up
          </v-btn>
          <v-btn
            round
            large
            color="error"
            class="mx-0"
            @click="$router.push('/client-balance-withdraw')"
          >
            Withdraw Balance
          </v-btn>
        </v-layout>
        <!-- <br /> -->
        <br />
        <h2>Transaction Details</h2>
        <br />
        <v-data-table
          :headers="headers"
          :items="transactions"
          class="elevation-1"
        >
          <template v-slot:items="props">
            <td class="text-xs-right">{{ props.item.id }}</td>
            <td class="text-xs-center">{{ props.item.trans_id }}</td>
            <td class="text-xs-right">
              <b class="text-success" v-if="props.item.debit_credit == 1">+</b>
              <b class="text-error" v-else-if="props.item.debit_credit == 0">
                -
              </b>
              {{ props.item.amount }}
            </td>
            <td class="text-xs-center">
              {{ props.item.transaction_at.split(" ")[0] }}
            </td>
            <td class="text-xs-center">{{ props.item.transaction_status }}</td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  import api from "../../api/datadash";
  import { mapState } from "vuex";
  import ProfileSidebar from "../../components/profile/ProfileSidebar.vue";
  export default {
    components: {
      ProfileSidebar,
    },
    data: () => ({
      headers: [
        {
          text: "ID",
          align: "right",
          sortable: true,
          value: "id",
        },
        {
          text: "Trx ID",
          align: "center",
          sortable: false,
          value: "trans_id",
        },
        {
          text: "Amount",
          align: "center",
          sortable: false,
          value: "amount",
        },
        {
          text: "Trx Date",
          align: "center",
          sortable: false,
          value: "transaction_at",
        },
        {
          text: "Status",
          align: "center",
          sortable: false,
          value: "transaction_status",
        },
      ],
      transactions: [],
      balance: null,
    }),
    computed: {
      ...mapState(["auth"]),
    },
    created() {
      this.fetchTransactions();
    },
    methods: {
      async fetchTransactions() {
        const { data } = await api.fetchData(this.auth.token, "client-profile");
        this.transactions = data.data.transactions;
        this.balance = data.data.balance;
      },
    },
  };
</script>
<style scoped>
  .space-between {
    justify-content: space-between;
  }
  .mw-20 {
    min-width: 18%;
  }
  .mw-20 h3 {
    font-weight: 500;
  }
  .text-success {
    color: green;
  }
  .text-error {
    color: red;
  }
</style>
